'use strict';
import {ngDepModel} from './ngdepmodel.js';

export class thesisModel extends ngDepModel {
    constructor(itemData, $filter, jsDataService){
        super(itemData, $filter, jsDataService);
        this.setupItemData(itemData);
    }

    getValue(name){
        switch(name){
            case 'datetime':
            case 'created':
            case 'updated':
                if (!this.datetime || this.datetime == 0) return '';
                return this.s('$filter')('u2date')(this.datetime, 'yyyy-MM-dd');
            case 'fname':
                return `${this.fname||''} ${this.lname||''}`.trim();

            case 'patvirtinta':
            case 'active':
            case 'apginta':
                return this.getClassifValue(name, 'apginta');

            case 'date_y':
            case 'date_m':
                return this[name] ?? '';

            case 'topic':
            case 'topic_lt':
            case 'topic_en':
                return this.topic_lt || this.topic_en || this.topic || '';

            case 'university':
                return this.university || this.institucija || this.location || '';

            case 'mkryptis': {
                let name = (this.msaka_lt || '').trim();
                if (name === '-') {
                    name = '';
                }
                const code = this.mkryptis ? String(this.mkryptis).trim() : '';
                if (name && code) return `${name} (${code})`;
                if (name) return name;
                if (code) return code;
                return '';
            }

            case 'field':
                return this.field || this.mskla_lt || this.mokslo_kryptis || '';

            default:
                if(typeof this[name] !== 'undefined' && this[name] !== '') return this[name];
                return '';
        }
    }
}
